import React from 'react';
import SvgIcon24 from '../svgIcon24';

/* eslint-disable max-len */
/* eslint-disable react/self-closing-comp */

const CreditCard = ({ ...others }) => (
  <SvgIcon24
    title="icons / nav / credit card"
    {...others}
  >
    <path d="M6.75 16.125C6.75 16.746 6.246 17.25 5.625 17.25C5.004 17.25 4.5 16.746 4.5 16.125C4.5 15.504 5.004 15 5.625 15C6.246 15 6.75 15.504 6.75 16.125Z" fill="#828282" />
    <path d="M10.5 16.125C10.5 15.504 9.996 15 9.375 15C8.754 15 8.25 15.504 8.25 16.125C8.25 16.746 8.754 17.25 9.375 17.25C9.996 17.25 10.5 16.746 10.5 16.125" fill="#828282" />
    <path d="M3 7.5H21V5.25H3V7.5ZM21 3.75H3C2.175 3.75 1.5 4.425 1.5 5.25V7.5V10.5H3H21H22.5V7.5V5.25C22.5 4.425 21.825 3.75 21 3.75V3.75Z" fill="#828282" />
    <path d="M21 18.75H3V12H1.5V18.75C1.5 19.575 2.175 20.25 3 20.25H21C21.825 20.25 22.5 19.575 22.5 18.75V12H21V18.75Z" fill="#828282" />

  </SvgIcon24>
);

export default CreditCard;
